import type { AttributeType } from 'cadenza/repository/model/attribute-type.gen';

// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

import i18n from './measure-aggregation.properties';

const MEASURE_AGGREGATION_TO_PERSISTENCE_KEY = {
  COUNT: 'count',
  COUNT_DISTINCT: 'count_distinct',
  SUM: 'sum',
  AVERAGE: 'avg',
  MEDIAN: 'median',
  STDDEV_SAMP: 'stddev_samp',
  MIN: 'min',
  MAX: 'max',
  CUSTOM: 'custom'
} as const;

/** @see net/disy/cadenza/attribute/olap/MeasureAggregation.java */
export type MeasureAggregation = keyof typeof MEASURE_AGGREGATION_TO_PERSISTENCE_KEY;

export const MeasureAggregation = {
  values: Object.keys(MEASURE_AGGREGATION_TO_PERSISTENCE_KEY) as readonly MeasureAggregation[],
  toPersistenceKey: (value: MeasureAggregation) => MEASURE_AGGREGATION_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = MeasureAggregation.values.find(key => MEASURE_AGGREGATION_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No MeasureAggregation for key: ${persistenceKey}`); }
    return value;
  },
  i18n: (value: MeasureAggregation) => i18n(`<${value}>`),
} as const;

// </GENERATED-CODE>

export function isMeasureAggregation(value: string): value is MeasureAggregation {
  return value in MEASURE_AGGREGATION_TO_PERSISTENCE_KEY;
}

/**
 * This function must be aligned with backend logic.
 * @see net.disy.cadenza.attribute.olap.ITotalsAggregation.getTargetAttributeType
 */
export function getTargetAttributeType(type: AttributeType, aggregation: MeasureAggregation): AttributeType {
  switch (aggregation) {
    case 'COUNT':
    case 'COUNT_DISTINCT':
      return type === 'LONG' ? type : 'INT';
    case 'AVERAGE':
    case 'STDDEV_SAMP':
      return type === 'BIGDECIMAL' || type === 'DURATION' ? type : 'DOUBLE';
    default:
      return type;
  }
}
